import { render, staticRenderFns } from "./ConfirmReceived.vue?vue&type=template&id=74d0b443&scoped=true&"
import script from "./ConfirmReceived.vue?vue&type=script&lang=js&"
export * from "./ConfirmReceived.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmReceived.vue?vue&type=style&index=0&id=74d0b443&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d0b443",
  null
  
)

export default component.exports